import HttpRequest from "./HttpRequest"

const mapOnlyId = (data) => {
  if (!data) {
    return data;
  }
  return data.map(({id}) => ({id}));
}

class AlertConfigurationsGroupsService {
  groupAlertUrl = 'alerts/v1/notifications-groups'
  httpRequest = new HttpRequest()

  async save(data) {
    data.friendlyName = mapOnlyId(data.friendlyName);
    data.active = mapOnlyId(data.active);
    if (data.id) {
      return this.httpRequest.put(`${this.groupAlertUrl}/${data.id}`, data)
    }
    return this.httpRequest.post(`${this.groupAlertUrl}`, data)
  }

  async saveV2(data) {
    return this.httpRequest.post(`${this.groupAlertUrl}`, data)
  }

  async getAlertGroupById(id) {
    return this.httpRequest.get(`${this.groupAlertUrl}/${id}`)
  }

  async deleteById(id) {
    return this.httpRequest.delete(`${this.groupAlertUrl}/${id}`)
  }

  async deleteGroupById(id) {
    return this.httpRequest.delete(`${this.groupAlertUrl}/${id}`)
  }
}

export {AlertConfigurationsGroupsService}


// WEBPACK FOOTER //
// ./src/services/AlertConfigurationsGroupsService.js